/**
 * adatok időben vizsgálandó frissességének vizsgálatára való osztály
 */
export default class LoadedDataValidity {
  /**
   * @param {Number} secondsToBeOutDated
   */
  constructor(secondsToBeOutDated) {
    if (secondsToBeOutDated === undefined) {
      throw new Error('Kötelező megadni másodpercet amihez hasonlítani fogunk!')
    }
    this.secondsToBeOutDated = secondsToBeOutDated
  }

  /**
   * vizsgálandó dátumot állítja be mostanira
   */
  setDateToInspect(date = null) {
    if (date === null) {
      this.dateToInspect = new Date()
    } else {
      this.dateToInspect = date
    }
  }

  /**
   * vizsgálandó unseteli
   */
  resetDateToInspect() {
    this.dateToInspect = undefined
  }

  /**
   * kapott másodpercet nézve megmondja hogy friss-e az adat
   *
   * @param {Number} secondsToBeOutDated
   * @return {boolean}
   */
  isUpToDate() {
    if (this.secondsToBeOutDated === undefined || this.dateToInspect === undefined) {
      return false
    }
    // az eltelt másodpercek az adatok betöltése óta több-e mint ami lehet, mielőtt lejártnak tekintünk egy adatot
    return Math.abs(new Date() - this.dateToInspect) / 1000 < this.secondsToBeOutDated
  }
}
